<template>
  <div>
    <!-- header-->
    <div class="flex flex-wrap items-center mb-4 gap-2">
      <div class="flex items-center gap-4">
        <h3>
          총 <span style="color: #7e72f2">{{ total }}</span
          >명
        </h3>
        <vs-button class="py-2 px-6" color="secondary" type="border" @click="onClickExcelDownload">엑셀 다운로드</vs-button>
      </div>
      <div class="ml-auto flex items-center gap-4">
        <vs-button class="py-2 px-6" color="secondary" @click="loadPostList">새로고침</vs-button>
      </div>
    </div>

    <!-- 검색 필터 -->
    <div class="bg-gray-50 p-4 rounded-lg mb-4">
      <div class="flex flex-wrap items-end gap-4 mb-4">
        <div class="flex-1 min-w-48">
          <label class="block font-medium text-gray-700 mb-1">이름 검색</label>
          <search-keyword class="w-full" label="" v-model="filters.keyword" placeholder="이름을 입력하세요." />
        </div>
        <div class="flex-1 min-w-32">
          <label class="block font-medium text-gray-700 mb-1">시험결과</label>
          <vs-select v-model="filters.examResult" placeholder="전체">
            <vs-select-item text="전체" value=""></vs-select-item>
            <vs-select-item text="합격" value="합격"></vs-select-item>
            <vs-select-item text="불합격" value="불합격"></vs-select-item>
            <vs-select-item text="미응시" value="미응시"></vs-select-item>
          </vs-select>
        </div>
        <div class="flex-1 min-w-32">
          <label class="block font-medium text-gray-700 mb-1">수강일 시작</label>
          <date-selector v-model="filters.startDate" />
        </div>
        <div class="flex-1 min-w-32">
          <label class="block font-medium text-gray-700 mb-1">수강일 종료</label>
          <date-selector v-model="filters.endDate" />
        </div>
        <div class="flex gap-2">
          <vs-button class="py-2 px-6" color="primary" @click="applyFilters">필터 적용</vs-button>
          <vs-button class="py-2 px-6" color="secondary" type="border" @click="resetFilters">초기화</vs-button>
        </div>
      </div>
    </div>

    <!-- Desktop Table -->
    <div class="hidden md:block overflow-x-auto">
      <table class="w-full modern-table">
        <colgroup>
          <col style="min-width: 80px" />
          <col style="min-width: 180px" />
          <col style="min-width: 80px" />
          <col style="min-width: 180px" />
          <col style="min-width: 120px" />
          <col style="min-width: 120px" />
          <col style="min-width: 100px" />
          <col style="min-width: 100px" />
        </colgroup>
        <thead>
          <tr>
            <th class="sortable" @click="sortBy('no')">
              No.
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== 'no'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === 'no' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === 'no' && sortDirection === 'desc'"></i>
              </span>
            </th>
            <th class="sortable" @click="sortBy('업체명')">
              업체명
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== '업체명'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === '업체명' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === '업체명' && sortDirection === 'desc'"></i>
              </span>
            </th>
            <th class="sortable" @click="sortBy('직급')">
              직급
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== '직급'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === '직급' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === '직급' && sortDirection === 'desc'"></i>
              </span>
            </th>
            <th class="sortable" @click="sortBy('이름')">
              이름
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== '이름'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === '이름' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === '이름' && sortDirection === 'desc'"></i>
              </span>
            </th>
            <th class="sortable" @click="sortBy('수강일시')">
              수강일시
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== '수강일시'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === '수강일시' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === '수강일시' && sortDirection === 'desc'"></i>
              </span>
            </th>
            <th class="sortable" @click="sortBy('교육이수일')">
              교육이수일
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== '교육이수일'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === '교육이수일' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === '교육이수일' && sortDirection === 'desc'"></i>
              </span>
            </th>
            <th class="sortable" @click="sortBy('수강률')">
              수강률
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== '수강률'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === '수강률' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === '수강률' && sortDirection === 'desc'"></i>
              </span>
            </th>
            <th class="sortable" @click="sortBy('시험결과')">
              시험결과
              <span class="sort-icon">
                <i class="fas fa-sort" v-if="sortColumn !== '시험결과'"></i>
                <i class="fas fa-sort-up" v-if="sortColumn === '시험결과' && sortDirection === 'asc'"></i>
                <i class="fas fa-sort-down" v-if="sortColumn === '시험결과' && sortDirection === 'desc'"></i>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in sortedAndFilteredList" :key="index" class="hover:bg-gray-50" :class="getRowClass(item.시험결과)">
            <td>{{ (page - 1) * perPage + index + 1 }}</td>
            <td>{{ item.업체명 }}</td>
            <td>{{ item.직급 }}</td>
            <td class="font-medium">{{ item.이름 }}</td>
            <td>{{ formatDate(item.수강일시) }}</td>
            <td>{{ item.교육이수일 }}</td>
            <td>
              <div class="flex items-center gap-2">
                <div class="w-16 bg-gray-200 rounded-full h-2">
                  <div class="bg-blue-500 h-2 rounded-full" :style="{ width: item.수강률 }"></div>
                </div>
                <span class="">{{ item.수강률 }}</span>
              </div>
            </td>
            <td>
              <span class="px-2 py-1 rounded-full font-medium" :class="getExamResultClass(item.시험결과)">
                {{ item.시험결과 }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile Cards -->
    <div class="md:hidden space-y-4">
      <div v-for="(item, index) in sortedAndFilteredList" :key="index" class="bg-white rounded-lg shadow p-4 border">
        <div class="flex justify-between items-start mb-3">
          <div class="flex items-center gap-2">
            <span class="bg-blue-100 text-blue-800 font-medium px-2 py-1 rounded">
              {{ (page - 1) * perPage + index + 1 }}
            </span>
            <span class="font-medium text-lg">{{ item.이름 }}</span>
          </div>
          <span class="px-2 py-1 rounded-full font-medium" :class="getExamResultClass(item.시험결과)">
            {{ item.시험결과 }}
          </span>
        </div>

        <div class="grid grid-cols-1 gap-2">
          <div class="flex justify-between">
            <span class="text-gray-600">업체명:</span>
            <span class="font-medium">{{ item.업체명 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">직급:</span>
            <span>{{ item.직급 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">수강일시:</span>
            <span>{{ formatDate(item.수강일시) }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">교육이수일:</span>
            <span>{{ item.교육이수일 }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-gray-600">수강률:</span>
            <div class="flex items-center gap-2">
              <div class="w-16 bg-gray-200 rounded-full h-2">
                <div class="bg-blue-500 h-2 rounded-full" :style="{ width: item.수강률 }"></div>
              </div>
              <span class="">{{ item.수강률 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 빈 결과 안내 -->
    <div v-if="sortedAndFilteredList.length === 0" class="text-center py-12">
      <div class="text-gray-500 text-lg mb-2">검색 결과가 없습니다</div>
      <div class="text-gray-400">검색 조건을 변경해 보세요.</div>
    </div>

    <!-- 페이지네이션 -->
    <div class="py-6 vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="totalPages" :value="page" @input="changePage"></k-pagination>
      </div>
    </div>

    <popup-excel-download v-if="download" v-model="download" :list="list" :title="`안전보건교육수강_${this.title}`" :z-index="999999" />
  </div>
</template>

<script>
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";
import PopupApprovalProcess from "@/views/approval/PopupApprovalProcess.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import * as UIUtil from "@/util/UiUtil";

export default {
  name: "StudentList",
  components: { PopupApprovalProcess, PopupExcelDownload, KPagination, SearchKeyword, DateSelector },
  props: {
    info: Object,
    videoPostId: [Number, String],
    title: String,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    body() {
      let body = {};
      if (this.data && this.data.body) {
        body = { ...this.data.body };
        body.created_at = this.data.created_at;
      }
      return body;
    },
    filteredList() {
      return this.list.filter((item) => {
        // 이름 필터
        if (this.filters.keyword && !item.이름.includes(this.filters.keyword)) {
          return false;
        }

        // 시험결과 필터
        if (this.filters.examResult && item.시험결과 !== this.filters.examResult) {
          return false;
        }

        // 수강일시 필터
        if (this.filters.startDate || this.filters.endDate) {
          const itemDate = new Date(item.수강일시);
          const startDate = this.filters.startDate ? new Date(this.filters.startDate) : null;
          const endDate = this.filters.endDate ? new Date(this.filters.endDate) : null;

          if (startDate && itemDate < startDate) {
            return false;
          }
          if (endDate && itemDate > endDate) {
            return false;
          }
        }

        return true;
      });
    },
    sortedList() {
      if (!this.sortColumn) return this.filteredList;

      const sorted = [...this.filteredList].sort((a, b) => {
        let aValue = null;
        let bValue = null;

        if (this.sortColumn === "no") {
          aValue = this.list.indexOf(a) + 1;
          bValue = this.list.indexOf(b) + 1;
        } else if (this.sortColumn === "수강률") {
          aValue = parseFloat(a.수강률.replace("%", ""));
          bValue = parseFloat(b.수강률.replace("%", ""));
        } else if (this.sortColumn === "수강일시") {
          aValue = new Date(a.수강일시);
          bValue = new Date(b.수강일시);
        } else {
          aValue = a[this.sortColumn];
          bValue = b[this.sortColumn];
        }

        if (aValue < bValue) return this.sortDirection === "asc" ? -1 : 1;
        if (aValue > bValue) return this.sortDirection === "asc" ? 1 : -1;
        return 0;
      });

      return sorted;
    },
    sortedAndFilteredList() {
      const start = (this.page - 1) * this.perPage;
      const end = start + this.perPage;
      return this.sortedList.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.sortedList.length / this.perPage) || 1;
    },
  },
  data() {
    return {
      // 현재 페이지
      page: 1,
      // 페이지당 게시글 수
      perPage: 20,
      // 마지막 페이지
      lastPage: 1,
      total: 0,

      // 필터 관련
      filters: {
        keyword: "",
        examResult: "",
        startDate: "",
        endDate: "",
      },

      // 정렬 관련
      sortColumn: "",
      sortDirection: "asc",

      list: [],
      listAll: [],

      download: false,
    };
  },
  methods: {
    initLoadPostList() {
      this.page = 1;
      this.loadPostList();
    },
    async loadPostList() {
      if (!this.videoPostId) return;
      try {
        UIUtil.loading(true);
        let page = 1;
        const payload = {
          projectId: this.projectId,
          boardId: 1065,
          page,
          perPage: 100,
          withMeta: true,
          withoutRelation: true, // author 정보가 필요하므로 false
          onlyMeta: true,
          metaKeys: ["body.watchedSeconds", "body.시험결과", "body.교육이수일", "updated_at", "author.name", "author.company_id", "author.company.com_name", "author.department", "author.rank"],
          conditions: [
            {
              key: "body.videoPostId",
              operator: "=",
              value: this.videoPostId,
            },
          ],
        };

        const list = [];
        let listInfo = null;

        do {
          payload.page = page;
          listInfo = await this.$store.dispatch("board/LOAD_POST_LIST", payload, false);
          list.push(
            ...listInfo.data.map((item) => {
              const contents = item.postContents || {};
              console.log("contents", contents)
              const body = item.postContents.body;

              const companyId = Number(contents.author.company_id) || 0;
              let companyName = contents.author.company.com_name;
              if ([914, 915, 916, 917].includes(companyId)) {
                companyName = contents.author.department;
              } else if (companyId === 918) {
                if (contents.author.department) {
                  companyName = `${companyName} (${contents.author.department})`;
                }
              }

              return {
                업체명: companyName,
                직급: contents.author.rank,
                이름: contents.author.name,
                수강일시: contents.updated_at,
                교육이수일: contents.body.교육이수일,
                수강률: this.info ? `${parseInt((body.watchedSeconds / this.info.duration) * 10000) / 100}%` : "0%",
                시험결과: body.시험결과 || "미응시",
              };
            })
          );
          page++;
        } while (listInfo.data.length > 0 && page <= listInfo.last_page);

        this.list = list;
        this.total = listInfo.total;
        this.lastPage = list.length === 0 ? 1 : Math.ceil(this.total / this.perPage);
      } finally {
        UIUtil.loading(false);
      }
    },
    changePage(page) {
      this.page = page;
    },
    async onClickExcelDownload() {
      this.download = true;
    },

    // 필터 관련 메서드
    applyFilters() {
      this.page = 1; // 필터 적용 시 첫 페이지로 이동
    },
    resetFilters() {
      this.filters = {
        keyword: "",
        examResult: "",
        startDate: "",
        endDate: "",
      };
      this.page = 1;
    },

    // 정렬 관련 메서드
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortDirection = "asc";
      }
      this.page = 1; // 정렬 시 첫 페이지로 이동
    },

    // 유틸리티 메서드
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("ko-KR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getExamResultClass(result) {
      switch (result) {
        case "합격":
          return "exam-result-pass";
        case "불합격":
          return "exam-result-fail";
        case "미응시":
          return "exam-result-pending";
        default:
          return "exam-result-pending";
      }
    },
    getRowClass(result) {
      if (!result) return "";
      if (result === "합격") return "exam-result-pass";
      if (result === "불합격") return "exam-result-fail";
      if (result === "미응시") return "exam-result-pending";
      return "";
    },
  },
};
</script>

<style scoped lang="scss">
// 기본 테이블 스타일 (기존 호환성 유지)
table {
  border-collapse: collapse;
  border-top: 1px solid #cdcdcd;

  th {
    background-color: #f9f9f9;
    text-align: center;
    padding: 0.5rem;
    font-weight: 500;
    border-bottom: 1px solid #cdcdcd;
  }

  td {
    text-align: center;
    padding: 0.5rem;
    font-weight: 400;
    color: #3c3c3c;
    border-bottom: 1px solid #cdcdcd;
  }
}

// 개선된 테이블 스타일 (옅은 색상)
.modern-table {
  border-collapse: collapse;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: white;
  font-size: 14px;

  th {
    background: #eaeaea;
    color: #4a5568;
    font-weight: 600;
    padding: 1rem 0.75rem;
    text-align: center;
    border: none;
    position: relative;
    user-select: none;
    font-size: 14px;

    &.sortable {
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: #dadada;
        color: #374151;
      }
    }

    .sort-icon {
      margin-left: 0.5rem;
      font-size: 0.875rem;
      opacity: 0.6;

      i {
        transition: opacity 0.2s ease;
      }
    }
  }

  td {
    padding: 0.5rem 0.75rem;
    border-bottom: 1px solid #e5e7eb;
    color: #374151;
    font-size: 14px;

    &:first-child {
      font-weight: 600;
      color: #1f2937;
    }
  }

  tbody tr {
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    // 합격 행 호버 효과
    &.exam-result-pass:hover {
      background-color: #b3ffca;
      border-left: 4px solid #22c55e;
    }

    // 불합격 행 호버 효과
    &.exam-result-fail:hover {
      background-color: #ffacac;
      border-left: 4px solid #ef4444;
    }

    // 미응시 행 호버 효과
    &.exam-result-pending:hover {
      background-color: #f9fafb;
      border-left: 4px solid #6b7280;
    }

    &:last-child td {
      border-bottom: none;
    }
  }
}

// 반응형 디자인
@media (max-width: 768px) {
  .modern-table {
    font-size: 14px;

    th,
    td {
      padding: 0.5rem 0.25rem;
    }
  }
}

// 시험결과별 색상 및 마우스 오버 효과
.exam-result-pass {
  background-color: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
  transition: all 0.3s ease;

  &:hover {
    background-color: #bbf7d0;
    color: #14532d;
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
  }
}

.exam-result-fail {
  background-color: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
  transition: all 0.3s ease;

  &:hover {
    background-color: #fecaca;
    color: #7f1d1d;
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  }
}

.exam-result-pending {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e5e7eb;
    color: #1f2937;
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(107, 114, 128, 0.3);
  }
}

// 테이블 행 호버 시 시험결과 색상 유지
.modern-table tbody tr:hover {
  .exam-result-pass {
    background-color: #bbf7d0;
    color: #14532d;
  }

  .exam-result-fail {
    background-color: #fecaca;
    color: #7f1d1d;
  }

  .exam-result-pending {
    background-color: #e5e7eb;
    color: #1f2937;
  }
}
</style>
